import * as Types from '../constants/Types';
import { PAGINATION } from '../constants/Define';

const initialState = {
    isFetching: false,
    ticketSolds: [],
    pageSize: PAGINATION.pageSize,
    pageIndex: PAGINATION.pageIndex,
    totalCount: PAGINATION.totalCount,
};

export default (state = initialState, action) => {
    switch (action.type) {
        case Types.TICKET_SOLD_LIST_ACTION:
            return { ...state, isFetching: true };
        case Types.TICKET_SOLD_LIST_SUCCESS:
            return { 
                ...state, 
                isFetching: false, 
                ticketSolds: action.ticketSolds.result,
                pageSize: action.ticketSolds.pageSize,
                pageIndex: action.ticketSolds.pageIndex,
                totalCount: action.ticketSolds.totalCount,
                totalPage: Math.ceil(parseInt(action.ticketSolds.totalCount) / parseInt(action.ticketSolds.pageSize))
            };
        case Types.TICKET_SOLD_LIST_FAIL:
            return { ...state, isFetching: false }
        default:
            return state;
    }
}
